/**
 * Required fields before an operator can leave Account and operate games.
 */
export function isOperatorProfileComplete(fields: {
  firstName?: string | null;
  name?: string | null;
  phoneNumber?: string | null;
  avatarUrl?: string | null;
  avatarKey?: string | null;
  hasAvatar?: boolean | null;
  addressLine1?: string | null;
  addressCity?: string | null;
  addressState?: string | null;
  addressZip?: string | null;
}): boolean {
  const hasPhoto = Boolean(
    fields.hasAvatar
    || String(fields.avatarUrl || "").trim()
    || String(fields.avatarKey || "").trim(),
  );
  return Boolean(
    String(fields.firstName || "").trim()
    && String(fields.name || "").trim()
    && String(fields.phoneNumber || "").trim()
    && hasPhoto
    && String(fields.addressLine1 || "").trim()
    && String(fields.addressCity || "").trim()
    && String(fields.addressState || "").trim()
    && String(fields.addressZip || "").trim(),
  );
}

export function formatOperatorMailingAddress(fields: {
  addressLine1?: string | null;
  addressCity?: string | null;
  addressState?: string | null;
  addressZip?: string | null;
}): string {
  const line1 = String(fields.addressLine1 || "").trim();
  const city = String(fields.addressCity || "").trim();
  const state = String(fields.addressState || "").trim();
  const zip = String(fields.addressZip || "").trim();
  const cityState = [city, state].filter(Boolean).join(", ");
  const cityStateZip = [cityState, zip].filter(Boolean).join(" ");
  return [line1, cityStateZip].filter(Boolean).join("\n");
}
